module.exports = __webpack_public_path__ + "img/syukyaku-kaisya-001sp.2cd34618.jpg";